import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../atomic/text/Text';
import style from '../../IndividualTacticStyle.module.css';

export const ScalingInTacticPanelHeader = () => {
  return (
    <thead>
      <tr style={{ backgroundColor: colors.grey }}>
        <th className={style.fieldHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            #
          </Body3>
        </th>
        <th className={style.valueHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Qty./Dollar Amount
          </Body3>
        </th>
        <th className={style.fieldHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Break Price
          </Body3>
        </th>
        <th className={style.fieldHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Add/Remove
          </Body3>
        </th>
      </tr>
    </thead>
  );
};
